import { nullElementzitp7se36veh as nullElement } from '../../../../../lightning-server-shared/com/lightningkite/serialization/SerializationHelpers.mjs';
import { enumValues198w9mpbetxy6 as enumValues } from './default.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { plus310ted5e4i90h as plus } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KtList3hktaavzmj137 as KtList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  _Constant___init__impl__v45mub34czko7zopf6l as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
} from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import {
  VirtualEnumValue3slftlp5rcob7 as VirtualEnumValue,
  StringValue3u4w9lwhg0ah4 as StringValue,
  getElementSerializableAnnotations1zu2f30o6pbok as getElementSerializableAnnotations,
} from '../../../../../lightning-server-shared/com/lightningkite/serialization/VirtualType.mjs';
import { titleCasej01kvzva6qlf as titleCase } from '../../casing.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import {
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { ENUM_getInstance22lfbrqor0c0a as ENUM_getInstance } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import {
  Companion_instancegwok6qx7et5m as Companion_instance,
  Companion_instance17v8p6g2424o4 as Companion_instance_0,
  get_type3f1sl153qhh1c as get_type,
  get_nullable1f61etx34dvfo as get_nullable,
  get_annotation27eynvnd00ffx as get_annotation,
  get_handlesField2upaii4zzjnxm as get_handlesField,
  size1hf9cj08wgoyn as size,
  priority7vn90mx06311 as priority,
  matches2uu672wulv59r as matches,
  Generator2kgtccb0jt0mi as Generator,
  Generator1qrulkrel7e5m as Generator_0,
} from './FormRenderer.mjs';
import { FieldSemantic_getInstance2sngfoinp7a00 as FieldSemantic_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { Select2osqjs95yxuh6 as Select } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Select.commonHtml.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var TypeInfoClass;
function TypeInfo() {
  if (TypeInfoClass === VOID) {
    class $ {
      constructor(serializer) {
        this.udu_1 = serializer;
        var tmp = this;
        var tmp0_elvis_lhs = nullElement(this.udu_1);
        // Inline function 'kotlin.let' call
        var it = enumValues(tmp0_elvis_lhs == null ? this.udu_1 : tmp0_elvis_lhs);
        var tmp_0 = this.udu_1.az().l11() ? plus(listOf(null), it) : it;
        tmp.vdu_1 = _Constant___init__impl__v45mub(isInterface(tmp_0, KtList()) ? tmp_0 : THROW_CCE());
      }
      wdu(it) {
        var tmp;
        if (it == null) {
          tmp = 'N/A';
        } else {
          var tmp0_safe_receiver = it instanceof VirtualEnumValue() ? it : null;
          var tmp_0;
          if (tmp0_safe_receiver == null) {
            tmp_0 = null;
          } else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.let' call
            var it_0 = tmp0_safe_receiver.b4u_1.p4t_1.q1(tmp0_safe_receiver.c4u_1);
            // Inline function 'kotlin.collections.find' call
            var tmp0 = it_0.y4t_1;
            var tmp$ret$1;
            $l$block: {
              // Inline function 'kotlin.collections.firstOrNull' call
              var _iterator__ex2g4s = tmp0.m1();
              while (_iterator__ex2g4s.n1()) {
                var element = _iterator__ex2g4s.o1();
                if (element.j4s_1 === 'com.lightningkite.lightningdb.DisplayName') {
                  tmp$ret$1 = element;
                  break $l$block;
                }
              }
              tmp$ret$1 = null;
            }
            var tmp0_safe_receiver_0 = tmp$ret$1;
            var tmp1_safe_receiver = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.k4s_1;
            var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.p3('text');
            var tmp_1;
            if (tmp2_safe_receiver == null) {
              tmp_1 = null;
            } else {
              // Inline function 'kotlin.let' call
              tmp_1 = tmp2_safe_receiver instanceof StringValue() ? tmp2_safe_receiver : null;
            }
            var tmp3_safe_receiver = tmp_1;
            var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.x4v_1;
            tmp_0 = tmp4_elvis_lhs == null ? titleCase(it_0.x4t_1) : tmp4_elvis_lhs;
          }
          var tmp1_elvis_lhs = tmp_0;
          var tmp_2;
          if (tmp1_elvis_lhs == null) {
            var tmp2_safe_receiver_0 = it instanceof Enum() ? it : null;
            var tmp_3;
            if (tmp2_safe_receiver_0 == null) {
              tmp_3 = null;
            } else {
              // Inline function 'kotlin.let' call
              // Inline function 'kotlin.collections.find' call
              var tmp0_0 = getElementSerializableAnnotations(this.udu_1, tmp2_safe_receiver_0.b4_1);
              var tmp$ret$10;
              $l$block_0: {
                // Inline function 'kotlin.collections.firstOrNull' call
                var _iterator__ex2g4s_0 = tmp0_0.m1();
                while (_iterator__ex2g4s_0.n1()) {
                  var element_0 = _iterator__ex2g4s_0.o1();
                  if (element_0.j4s_1 === 'com.lightningkite.lightningdb.DisplayName') {
                    tmp$ret$10 = element_0;
                    break $l$block_0;
                  }
                }
                tmp$ret$10 = null;
              }
              var tmp0_safe_receiver_1 = tmp$ret$10;
              var tmp1_safe_receiver_0 = tmp0_safe_receiver_1 == null ? null : tmp0_safe_receiver_1.k4s_1;
              var tmp2_safe_receiver_1 = tmp1_safe_receiver_0 == null ? null : tmp1_safe_receiver_0.p3('text');
              var tmp_4;
              if (tmp2_safe_receiver_1 == null) {
                tmp_4 = null;
              } else {
                // Inline function 'kotlin.let' call
                tmp_4 = tmp2_safe_receiver_1 instanceof StringValue() ? tmp2_safe_receiver_1 : null;
              }
              var tmp3_safe_receiver_0 = tmp_4;
              var tmp4_elvis_lhs_0 = tmp3_safe_receiver_0 == null ? null : tmp3_safe_receiver_0.x4v_1;
              tmp_3 = tmp4_elvis_lhs_0 == null ? titleCase(tmp2_safe_receiver_0.a4_1) : tmp4_elvis_lhs_0;
            }
            tmp_2 = tmp_3;
          } else {
            tmp_2 = tmp1_elvis_lhs;
          }
          var tmp3_elvis_lhs = tmp_2;
          tmp = tmp3_elvis_lhs == null ? titleCase(toString(it)) : tmp3_elvis_lhs;
        }
        return tmp;
      }
    }
    initMetadataForClass($, 'TypeInfo');
    TypeInfoClass = $;
  }
  return TypeInfoClass;
}
function EnumFormRenderer$TypeInfo$toDisplayName$ref(p0) {
  var l = (_this__u8e3s4) => p0.wdu(_this__u8e3s4);
  l.callableName = 'toDisplayName';
  return l;
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
var EnumFormRendererClass;
function EnumFormRenderer() {
  if (EnumFormRendererClass === VOID) {
    class $ {
      constructor() {
        EnumFormRenderer_instance = this;
        this.xdu_1 = 'Enum';
        this.ydu_1 = ENUM_getInstance();
      }
      i20() {
        return this.xdu_1;
      }
      edu() {
        return 0.7;
      }
      s11() {
        return this.ydu_1;
      }
      ndu(module_0, selector) {
        var info = new (TypeInfo())(selector.gdu_1);
        var tmp = Companion_instance;
        return tmp.odu(module_0, this, selector, VOID, VOID, ($this$FormRenderer, _unused_var__etf5q3, mutable) => {
          // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
          var tmp = $this$FormRenderer.jbb(FieldSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.direct.select' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (Select())($this$FormRenderer.pc());
          var tmp0_elvis_lhs = $this$FormRenderer.ebb_1;
          var p = tmp0_elvis_lhs == null ? $this$FormRenderer : tmp0_elvis_lhs;
          $this$FormRenderer.gbb(p, view);
          view.ocf(mutable, new (Constant())(info.vdu_1), EnumFormRenderer$TypeInfo$toDisplayName$ref(info));
          $this$FormRenderer.hbb(p, view);
          return $this$FormRenderer.lbb(tmp, view);
        });
      }
      pdu(module_0, selector) {
        var info = new (TypeInfo())(selector.gdu_1);
        var tmp = Companion_instance_0;
        return tmp.qdu(module_0, this, selector, VOID, VOID, ($this$ViewRenderer, _unused_var__etf5q3, readable) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (TextView())($this$ViewRenderer.pc());
          var tmp0_elvis_lhs = $this$ViewRenderer.ebb_1;
          var p = tmp0_elvis_lhs == null ? $this$ViewRenderer : tmp0_elvis_lhs;
          $this$ViewRenderer.gbb(p, view);
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl(view);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(view));
          reactiveScope(view, ($this$reactiveScope) => {
            var tmp$ret$0 = info.wdu($this$reactiveScope.daj(readable));
            this_0.set(tmp$ret$0);
            return Unit_instance;
          });
          $this$ViewRenderer.hbb(p, view);
          return view;
        });
      }
    }
    protoOf($).h94 = get_type;
    protoOf($).rdu = get_nullable;
    protoOf($).sdu = get_annotation;
    protoOf($).wds = get_handlesField;
    protoOf($).kdu = size;
    protoOf($).tdu = priority;
    protoOf($).fdu = matches;
    initMetadataForObject($, 'EnumFormRenderer', VOID, VOID, [Generator(), Generator_0()]);
    EnumFormRendererClass = $;
  }
  return EnumFormRendererClass;
}
var EnumFormRenderer_instance;
function EnumFormRenderer_getInstance() {
  if (EnumFormRenderer_instance === VOID)
    new (EnumFormRenderer())();
  return EnumFormRenderer_instance;
}
//region block: exports
export {
  EnumFormRenderer_getInstance as EnumFormRenderer_getInstance168is7m1qimls,
};
//endregion

//# sourceMappingURL=EnumFormRenderer.mjs.map
